/**
 * URL builders for the `/attribute-types` dictionary endpoints (types, their
 * values, and per-value aliases). Routes are mounted under `api/v1` by the
 * axios client's base URL.
 */
export const AttributeTypesEndpoints = {
    list: () => '/attribute-types',
    pendingValues: () => '/attribute-types/pending-values',
    details: (id: string) => `/attribute-types/${id}`,
    create: () => '/attribute-types',
    update: (id: string) => `/attribute-types/${id}`,
    delete: (id: string) => `/attribute-types/${id}`,
    createValue: (id: string) => `/attribute-types/${id}/values`,
    updateValue: (id: string, valueId: string) =>
        `/attribute-types/${id}/values/${valueId}`,
    deleteValue: (id: string, valueId: string) =>
        `/attribute-types/${id}/values/${valueId}`,
    reorderValues: (id: string) => `/attribute-types/${id}/values/order`,
    promoteValue: (id: string, valueId: string) =>
        `/attribute-types/${id}/values/${valueId}/promote`,
    createAlias: (id: string, valueId: string) =>
        `/attribute-types/${id}/values/${valueId}/aliases`,
    deleteAlias: (id: string, valueId: string, aliasId: string) =>
        `/attribute-types/${id}/values/${valueId}/aliases/${aliasId}`,
};
